(function($) {

  function checkMobile() {
    return $(window).innerWidth() <= 640;
  }

  $(document).ready(function() {
    $('.fixed-box').each(function() {

        var $elem = $(this);
            
        $(window).scroll(function() {

          var $content    = $elem,
              scroll      = $(document).scrollTop(),
              y           = $content.offset().top,
              originalTop = $content.data('original-top') !== undefined ?
                                $content.data('original-top') : y,
              scrolling   = $content.data('scrolling') || false,
              disabled    = false
              bottom      = $('footer').offset().top
              mobile      = checkMobile();

          if ($content.height() > $(window).innerHeight()) disabled = true;

          //start scrolling
          if (scroll > y && scrolling === false && mobile === false) {
            $content.data('scrolling', true);
            $content.data('original-top', y);
            $content.data('original-width', $content.width());
            $content.data('original-left', $content.position().left);
          }

          //stop scrolling
          if (originalTop !== undefined && scroll < originalTop || disabled) {
            $content.data('scrolling', false);
            $content.css({
                  position: 'static',
                  top: 'auto',
                  width: '100%'
                });
          }

          //update scrolling
          if (scrolling === true &&
              scroll - originalTop > 0 &&
              scroll + $content.height() < bottom) {
               $content.css({
                  position: 'absolute',
                  top: scroll - originalTop,
                  width: $content.parent().width()
                });
          }

        });

    });
  });

})(jQuery);
